export default __webpack_public_path__ + "static/92399274_235181431060521_2654762571251309465_n-0574687ccf31c05eb72fb60c3e7f40c2.jpg";